var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 44,
    viewBox: "0 0 31 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6461 0.207059C15.3339 -0.0690196 14.8482 -0.0690196 14.5013 0.207059L0.381626 12.1129C0.138781 12.32 0 12.6306 0 12.9757V42.7576C0 43.2408 0.381613 43.6204 0.867302 43.6204H17.9705C18.4562 43.6204 18.8378 43.2408 18.8378 42.7576V38.7545C18.8378 38.2714 18.4562 37.8918 17.9705 37.8918H8.11796C7.63227 37.8918 7.25065 37.5121 7.25065 37.029V15.2533C7.25065 14.9773 7.38942 14.7357 7.59758 14.5631L14.536 9.11059C14.8482 8.86903 15.2992 8.86903 15.6114 9.11059L22.5846 14.5976C22.7927 14.7702 22.9315 15.0118 22.9315 15.2878V42.7922C22.9315 43.2753 23.3131 43.6549 23.7988 43.6549H29.3495C29.8352 43.6549 30.2168 43.2753 30.2168 42.7922V13.0102C30.2168 12.6651 30.078 12.3545 29.8352 12.1475L15.6461 0.207059Z",
    fill: "#FFFFFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logoSm.50325018cef422f6732b704f872410d4.svg";
export { ForwardRef as ReactComponent };